import React from 'react';
import CommercialCart from './CommercialCart/CommercialCart';
import PanelComerciales from './PanelComerciales/PanelComerciales';
import UserInformation from './UserInformation/UserInformation';
import Validities from './Validities/Validities';
import Assignments from './Assignments/Assignments';
import CommercialSlots from './CommercialSlots/CommercialSlots';
import ExpandValidity from './ExpandValidity/ExpandValidity';
import Transactions from './Transactions/Transactions';
import { GatedFlagKey } from 'src/redux/permissions/permissions.types';

/**
 * Ids con nombre de las tabs legacy de ExpandValidity. Se exponen como constantes
 * para que la lógica que aún las referencia (expand_validity/api, ExpandValidityList)
 * no dependa de la posición dentro de `configFile`.
 */
export const EXPAND_VALIDITY_TAB = 'tab-expand-validity';
export const RETENTION_USERS_TAB = 'tab-retention-users';

export interface TabConfig {
    tab: string;
    tag: string;
    title: string;
    Contents: React.ComponentType<any>;
    hidden?: boolean;
    permissionKey: GatedFlagKey | null;
}

export const configFile: TabConfig[] = [
    {
        tab: 'tab-1',
        tag: 'span',
        title: 'Información del usuario',
        Contents: UserInformation,
        permissionKey: null,
    },
    {
        tab: 'tab-2',
        tag: 'span',
        title: 'Carrito Comercial',
        Contents: CommercialCart,
        permissionKey: null,
    },
    // Va después de Carrito Comercial por decisión de producto. El id NO sigue
    // el orden visual a propósito: `tab-3`…`tab-6` conservan su número (de él se
    // deriva el índice que emite `setActiveTab`, y tanto
    // `PANEL_COMERCIALES_TAB_INDEX` como `TRANSACTIONS_TAB_INDEX` dependen de eso).
    {
        tab: 'tab-7',
        tag: 'span',
        title: 'Transacciones',
        Contents: Transactions,
        permissionKey: 'transacciones',
    },
    {
        tab: 'tab-3',
        tag: 'span',
        title: 'Vigencias',
        Contents: Validities,
        permissionKey: 'vigencias',
    },
    {
        tab: 'tab-4',
        tag: 'span',
        title: 'Asignaciones',
        Contents: Assignments,
        permissionKey: 'asignaciones',
    },
    {
        tab: 'tab-5',
        tag: 'span',
        title: 'Slots comerciales',
        Contents: CommercialSlots,
        permissionKey: 'slots_comerciales',
    },
    {
        tab: 'tab-6',
        tag: 'span',
        title: 'Panel Comerciales',
        Contents: PanelComerciales,
        permissionKey: 'panel_comerciales',
    },
    // --- Tabs apagadas: se conservan ocultas por si se necesitan más adelante ---
    {
        tab: EXPAND_VALIDITY_TAB,
        tag: 'span',
        title: 'Expandir Vigencia',
        Contents: ExpandValidity,
        hidden: true,
        permissionKey: null,
    },
    {
        tab: RETENTION_USERS_TAB,
        tag: 'span',
        title: 'Retencion de usuarios',
        Contents: ExpandValidity,
        hidden: true,
        permissionKey: null,
    },
];

/** Índice (1-based) de la tab Panel Comerciales; coincide con el valor que setActiveTab emite */
export const PANEL_COMERCIALES_TAB_INDEX = 6;

/** Índice (1-based) de la tab Transacciones (`tab-7`); coincide con el valor que setActiveTab emite */
export const TRANSACTIONS_TAB_INDEX = 7;
